import { AxiosInstance } from "axios";
import { DeliveryApiClient } from "./DeliveryApiClient";

type ContentOptionsBase = {
    expand?: string;
    fields?: string;
    accept_Language?: string;
    api_Key?: string;
    preview?: boolean;
    start_Item?: string;
    cancelToken?: any;
};
export type GetContentOptions = ContentOptionsBase & {
    fetch?: string;
    filter?: string[];
    sort?: string[];
    skip?: number;
    take?: number;
};

export type GetContentOptionsById = ContentOptionsBase & {
    id: string;
};

export type GetContentOptionsByPath = ContentOptionsBase & {
    path: string;
};



export class DeliveryApiClientWrapper {
    instance: DeliveryApiClient;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = new DeliveryApiClient(baseUrl, instance);
    }

    public getContent = ({
        fetch,
        filter,
        sort,
        skip,
        take,
        expand,
        fields,
        accept_Language,
        api_Key,
        preview,
        start_Item,
        cancelToken,
    }: GetContentOptions) => {
        return this.instance
            .getContent2_0(
                fetch,
                filter,
                sort,
                skip,
                take ?? 1000,
                expand,
                fields,
                accept_Language,
                api_Key,
                preview,
                start_Item,
                cancelToken,
            );
    };

    public getContentByPath = ({
        path,
        expand,
        fields,
        accept_Language,
        api_Key,
        preview,
        start_Item,
        cancelToken,
    }: GetContentOptionsByPath) => {
        return this.instance
            .getContentItemByPath2_0(
                path,
                expand,
                fields,
                accept_Language,
                api_Key,
                preview,
                start_Item,
                cancelToken,
            );
    };

    public getContentById = ({
        id,
        expand,
        fields,
        accept_Language,
        api_Key,
        preview,
        start_Item,
        cancelToken,
    }: GetContentOptionsById) => {
        return this.instance
            .getContentItemById2_0(
                id,
                expand,
                fields,
                accept_Language,
                api_Key,
                preview,
                start_Item,
                cancelToken,
            );
    };
}